export default {
  category: 'book',
  name: 'The China Study',
  author: 'T. Colin Campbell',
  date: '10/1/20',
  path: '/notes/the-china-study',
  photo: 'https://twos.s3.amazonaws.com/parkerklein/parker-klein-the-china-study-t-colin-campbell.jpg',
  tags: ['Diet', 'Health', 'Nutrition', 'Food'],
  time: 3,
  rating: 8.2,
  review: '',
  link: 'https://www.amazon.com/China-Study-Comprehensive-Nutrition-Implications/dp/1932100660',
  mediumLink: '',
  patreonLink: '',
  // podcastLink: 'https://anchor.fm/parkerklein/episodes/',
  // podcastEmbed: 'https://anchor.fm/parkerklein/embed/episodes/',
  // youtubeLink: 'https://youtu.be/',
twosLink: '',
  // youtubeEmbed: 'https://www.youtube.com/embed/',
  releaseDate: ''
};
